import { motion } from "framer-motion";



const projects = [
  {
    title: "Agentic Data Intelligence Platform (ADIP)",
    role: "AI Platform Engineer",
    org: "Capco",
    client: "Top-tier global bank",
    dur: "Nov 2025 – Aug 2026",
    link: "/aegis-aidp",
  },
  {
    title: "ERD Script Compiler",
    role: "Platform Engineer",
    org: "Capco",
    client: "Top-tier global bank",
    dur: "Jan 2026",
    link: "/erd-script-compiler" ,
  },
  {
    title: "Effort Estimation",
    role: "Data Scientist",
    org: "Capco",
    client: "Top-tier global bank",
    dur: "Jul 2025 – Dec 2025",
    link: "/effort-estimation" ,
  },
  {
    title: "Customer Behavior Analysis",
    role: "Data Scientist",
    org: "Capco",
    client: "Top-tier global bank",
    dur: "May 2025 – Jul 2025",
    link: "/customer-behavior-analysis" ,
  },
  {
    title: "Multi Risk Rating",
    role: "Data Analyst",
    org: "Capco",
    client: "Top-tier global bank",
    dur: "Feb 2024 – May 2025",
    link: "/mrr" ,
  },
  {
    title: "AI Chatbot",
    role: "Data Scientist | AI Engineer",
    org: "Capco",
    client: "Capco",
    dur: "May 2023 – Jun 2024",
    link: "/ai-chatbot" ,
  },
  {
    title: "Problem Exposure Management",
    role: "Data Analyst",
    org: "Capco",
    client: "Top-tier global bank",
    dur: "Mar 2022 – Feb 2024",
    link: "/pem" ,
  },
];



function Resume() {
  return (
    <section
      id="resume"
      name="resume"
      className="bg-resume min-h-screen bg-gray-100 text-gray-800 px-6 py-16">
      <div className="site-container text-center">
        <h2 className="text-2xl sm:text-3xl font-bold title-color mb-6">
          <u>Work History</u>
        </h2>

        <div className="space-y-5">
          {/* Experience */}
          <motion.div
            initial={{ opacity: 0, scale: 0.95 }}
            whileInView={{ opacity: 1, scale: 1 }}
            transition={{ duration: 0.6, delay: 0 }}
            viewport={{ once: true }}
            className="p-5 sm:p-7 tile-color text-left"
          >
            {/* <h3 className="text-xl font-semibold text-blue-500">🚀 My Professional Journey at a Glance</h3> */}
            <p className="text-gray-700 mt-1 font-semibold">AI/ML, Data & Systems Engineering | Data Scientist | Big Data Analytics</p>
            <ul className="list-disc pl-6 text-gray-700 mt-2 space-y-0 text-justify">
              
              <li>
                <b>Business problems addressed:</b> Worked on data initiatives that helped teams make clearer, more reliable decisions in high-stakes banking and risk contexts.
              </li>

              <li>
                <b>Consistent delivery:</b> Contributed to and led multiple initiatives that moved from requirements to production within compressed timelines, without disrupting downstream teams.
              </li>

              <li>
                <b>Solutions built to endure:</b> Delivered systems that continued to be reused and extended as requirements evolved, reducing rework and repeated redesign efforts.
              </li>

              <li>
                <b>Practical adoption of advanced tools:</b> Implemented capabilities that reduced dependency on manual processes and made complex data more accessible to non-technical users.
              </li>

              <li>
                <b>Insights surfaced from data:</b> Supported exploratory analysis that helped teams better understand customer behavior and risk patterns, informing further model and policy discussions.
              </li>

              <li>
                <b>Early-stage clarity for stakeholders:</b> Helped stakeholders assess feasibility, effort, and data readiness early, leading to better-aligned expectations and prioritization.
              </li>

              <li>
                <b>Delivery within regulatory constraints:</b> Worked on platforms that required coordination across jurisdictions, ensuring delivery timelines remained aligned with governance requirements.
              </li>

              <li>
                <b>Cross-team execution:</b> Collaborated across analytics, engineering, and business teams to deliver outputs that were actively used rather than shelved.
              </li>

              <li>
                <b>Outcomes recognized:</b> Recognized with multiple client and organizational awards, including the Trailblazer Award and Client Innovation Award from a top-tier global bank, and High Five and Clap Awards, for delivery excellence, innovation, collaboration, and technical leadership.
              </li>

            </ul>
          </motion.div>

          {/* <motion.div
            initial={{ opacity: 0, scale: 0.95 }}
            whileInView={{ opacity: 1, scale: 1 }}
            transition={{ duration: 0.6, delay: 0 }}
            viewport={{ once: true }}
            className="p-6 tile-color rounded-xl shadow-md text-left hover:shadow-lg transition"
            whileHover={{ scale: 1 }}
          >
            <h3 className="text-xl font-semibold text-blue-500">🏅 Awards & Recognition</h3>
            <ul className="list-disc pl-6 text-gray-700 mt-2 space-y-0 text-justify">
              <li><b>Client Award</b> – <i>Top-tier global bank (Aug 2025):</i> For driving innovation and setting a benchmark in solution development and idea implementation.</li>
              <li><b>High Five</b> – <i>Capco (Apr 2025):</i> For excellence in collaboration and innovation.</li>
              <li><b>Clap Award</b> – <i>Capco (Oct 2022):</i> For outstanding contributions and delivery impact.</li>
            </ul>
          </motion.div> */}

          {/* Education */}
          {/* <motion.div
            initial={{ opacity: 0, scale: 0.95 }}
            whileInView={{ opacity: 1, scale: 1 }}
            transition={{ duration: 0.6, delay: 0 }}
            viewport={{ once: true }}
            className="p-6 bg-gray-50 rounded-xl shadow-md text-left hover:shadow-lg transition"
            whileHover={{ scale: 1 }}
          >
            <h3 className="text-xl font-semibold text-blue-500">Bachelor of Engineering (B.E.)</h3>
            <p className="text-gray-700 mt-0">NIIST, Bhopal | RGPV University | 2019</p>
            <p className="text-gray-700 mt-0">Percentage: 81.8%</p>
          </motion.div> */}

          <div id="resume-prof-projects" className="scroll-mt-[75px]">
            <h3 className="mt-12 mb-6 text-xl sm:text-2xl font-semibold title-color">
              Projects Delivered
            </h3>
            <div className="grid grid-cols-1 md:grid-cols-2 xl:grid-cols-3 gap-5 text-left">
              {projects.map((project, index) => (
                <motion.article
                  key={project.title}
                  initial={{ opacity: 0, y: 12 }}
                  whileInView={{ opacity: 1, y: 0 }}
                  transition={{ duration: 0.35, delay: Math.min(index * 0.04, 0.2) }}
                  viewport={{ once: true }}
                  className="tile-color flex flex-col gap-4 p-5 sm:p-6"
                >
                  <h4 className="text-lg font-semibold leading-snug text-blue-800">
                    {project.title}
                  </h4>
                  <dl className="grid grid-cols-[6.25rem_1fr] gap-x-2 gap-y-1 text-sm text-gray-700">
                    <dt className="font-semibold">Role</dt><dd>{project.role}</dd>
                    <dt className="font-semibold">Organization</dt><dd>{project.org}</dd>
                    <dt className="font-semibold">Client</dt><dd>{project.client}</dd>
                    <dt className="font-semibold">Duration</dt><dd>{project.dur}</dd>
                  </dl>
                  <a
                    href={project.link}
                    target="_blank"
                    rel="noopener noreferrer"
                    className="mt-auto inline-flex items-center gap-1 text-sm font-semibold text-blue-700 hover:text-blue-900"
                  >
                    View project details <span aria-hidden="true">↗</span>
                  </a>
                </motion.article>
              ))}
            </div>
          </div>

          {/* Resume Download Button */}
          {/* <div className="flex justify-center mt-6">
            <motion.div
              initial={{ opacity: 0, y: -30 }}
              whileInView={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.5, delay: 0 }}
              viewport={{ once: true }}
            >
              <a
                href="link"
                target="_blank"
                rel="noopener noreferrer"
                onClick={trackButtonClick}
                className="inline-block bg-blue-600 text-white py-3 px-6 rounded-lg hover:bg-blue-800 transition duration-300 shadow-md text-center"
              >
                View Comprehensive CV */}
                {/* <span className="block text-sm opacity-90">for more details</span> */}
              {/* </a>
            </motion.div>
          </div> */}
          
        </div>
      </div>
    </section>
  );
}

export default Resume;